import React from 'react';
import styled from 'styled-components';
import { Headline, Body } from '../../../../components/Typography';
import ConfirmButton from '../../OrderSettingModal/components/ConfirmButton';
import UnavailableMessage from '../../OrderSettingModal/components/UnavailableMessage';
import {
  renderMessageText,
  orderingIsAvailable,
} from '../../OrderSettingModal/utils/helper';
import { getOpeningHour } from '../../../OrderSetting/utils/helper';
import appConfig from '../../../../../app-config';

const Wrapper = styled.div`
  padding: 20px 18px 20px 13px;
  border-radius: 9.6px;
  box-shadow: 0 5px 16px 0 rgba(20, 19, 33, 0.12);
  background-color: #fff;
  margin-bottom: 18px;
  align-items: center;
  cursor: pointer;
  border: 2px solid
    ${(props) =>
      props.isCurrentStore ? props.theme.primaryButtonBackgroundColor : 'none'};
  min-height: 170px;
  max-width: 500px;
  :hover {
    box-shadow: 0 2px 7px 0 rgba(20, 19, 33, 0.24);
  }
  display: grid;
`;

const MainContent = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-gap: 10px;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const InformationDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  text-align: left;
`;

const SecondColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  align-items: flex-end;
  align-content: space-between;
`;

const ButtonDiv = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
`;

const LocationAddress = styled(Body)`
  margin-top: 9px;
`;

const ThresholdFeeText = styled(Body)`
  color: ${(props) => props.theme.primaryButtonFontColor};
`;

const ImageDiv = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
`;

const LocationCard = ({
  marketplaceDeliveryLocation,
  confirmMarketplaceDeliverySelection,
  deliveryLocation,
  isCurrentStore,
  checkUnavailableProductForMarketplace,
  resetInterSelectedDateTime,
  interOrderType,
  confirmDeliveryDetails,
  getTimeIntervalsDate,
  interDeliveryDetails,
  deliveryDetails,
  updateInterDeliveryDetails,
  isRequesting,
  setMarketplaceDeliverySelection,
  validateCartForLocation,
  setDeliveryTimeFormIsVisible,
}) => {
  const openingHour =
    marketplaceDeliveryLocation && marketplaceDeliveryLocation.deliveryBusiness
      ? getOpeningHour(marketplaceDeliveryLocation.deliveryBusiness)
      : null;

  const orderingIsAvailableResult =
    marketplaceDeliveryLocation && marketplaceDeliveryLocation.deliveryBusiness
      ? orderingIsAvailable(
          marketplaceDeliveryLocation.deliveryBusiness,
          marketplaceDeliveryLocation.deliveryBusiness.ordering_hours
        )
      : null;

  const thresholdFee =
    marketplaceDeliveryLocation?.delivery_zone?.threshold_fee;
  const deliveryFee = marketplaceDeliveryLocation?.delivery_zone?.fee;
  const distance = (marketplaceDeliveryLocation?.distance / 1000).toFixed(1);
  const name = marketplaceDeliveryLocation?.deliveryBusiness?.name || '';

  return (
    <Wrapper isCurrentStore={isCurrentStore}>
      <MainContent
        data-cy={`marketplace-delivery-location-card-${name}`}
        onClick={() => {
          resetInterSelectedDateTime();
          setDeliveryTimeFormIsVisible(true, marketplaceDeliveryLocation);
          // validateCartForLocation(marketplaceDeliveryLocation);
        }}
      >
        <ImageDiv>
          <img
            width="100"
            height="100"
            src={marketplaceDeliveryLocation.deliveryBusiness.image_url}
          />
        </ImageDiv>
        <InformationDiv>
          <Headline>
            {marketplaceDeliveryLocation.deliveryBusiness.name}
          </Headline>
          <LocationAddress>
            {marketplaceDeliveryLocation.deliveryBusiness.line1},{' '}
            {marketplaceDeliveryLocation.deliveryBusiness.city}
          </LocationAddress>
          {!marketplaceDeliveryLocation.deliveryBusiness
            .is_order_ahead_enabled ||
          !marketplaceDeliveryLocation.deliveryBusiness.accepting_orders ? (
            <Body>💤 Closed</Body>
          ) : openingHour &&
            marketplaceDeliveryLocation.deliveryBusiness.accepting_orders ? (
            <Body>Order until {openingHour} </Body>
          ) : null}
          {deliveryFee && deliveryFee > 0 ? (
            <Body>${deliveryFee} Delivery Fee</Body>
          ) : deliveryFee === 0 ? (
            <Body>Free Delivery </Body>
          ) : null}
          {thresholdFee === 0 ? (
            <ThresholdFeeText>
              Free Delivery Over $
              {marketplaceDeliveryLocation?.delivery_zone?.threshold}
            </ThresholdFeeText>
          ) : thresholdFee && thresholdFee >= 0 ? (
            <ThresholdFeeText>
              ${thresholdFee} Delivery Fee Over $
              {marketplaceDeliveryLocation?.delivery_zone?.threshold}
            </ThresholdFeeText>
          ) : null}
        </InformationDiv>
        <SecondColumn>
          {distance == 0 ? <Body>0 km</Body> : <Body>{distance} km</Body>}
          <ButtonDiv>
            <ConfirmButton
              text={
                isCurrentStore
                  ? 'Confirm'
                  : marketplaceDeliveryLocation.deliveryBusiness
                      .is_order_ahead_enabled && orderingIsAvailableResult
                  ? 'Order Here'
                  : 'See Menu'
              }
              style={{
                borderRadius: '18px',
                minWidth: '110px',
                fontSize: '14px',
              }}
              onClick={() => {
                resetInterSelectedDateTime();
                setDeliveryTimeFormIsVisible(true, marketplaceDeliveryLocation);
                // validateCartForLocation(marketplaceDeliveryLocation);
              }}
            />
          </ButtonDiv>
        </SecondColumn>
      </MainContent>
      {!marketplaceDeliveryLocation.deliveryBusiness.is_order_ahead_enabled ? (
        <UnavailableMessage
          title="Selected location is unable to accept orders at the moment"
          marginTop="15px"
        />
      ) : !orderingIsAvailableResult ||
        !marketplaceDeliveryLocation.deliveryBusiness.accepting_orders ? (
        <UnavailableMessage
          marginTop="15px"
          title={renderMessageText(
            interOrderType,
            marketplaceDeliveryLocation.deliveryBusiness.ordering_hours,
            []
          )}
        />
      ) : marketplaceDeliveryLocation &&
        !marketplaceDeliveryLocation.isDeliveryValid ? (
        <UnavailableMessage
          marginTop="15px"
          title={
            marketplaceDeliveryLocation.errorMessage ||
            'We are unable to deliver to this address'
          }
        />
      ) : null}
    </Wrapper>
  );
};

export default LocationCard;
